module.exports = __webpack_public_path__ + "apple-icon-144x144.b4c754a3.png";